import React from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  return <div className="w-full max-w-3xl mx-auto my-10 bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-111">
      <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-112">
        <div className="p-4 text-center border-r border-gray-200" data-id="element-113">
          <h3 className="font-bold text-gray-500 text-sm md:text-base" data-id="element-114">
            Senza Padel 360
          </h3>
        </div>
        <div className="p-4 text-center bg-blue-600" data-id="element-115">
          <h3 className="font-bold text-white text-sm md:text-base" data-id="element-116">
            Con Padel 360
          </h3>
        </div>
      </div>

      <div className="divide-y divide-gray-100" data-id="element-117">
        {[['Dolori costanti dopo ogni partita', 'Recupero rapido e zero dolori'], ['Tecnica stagnante da mesi', 'Miglioramento continuo e visibile'], ['Confusione tattica in campo', 'Schemi chiari e decisioni rapide'], ['Rischio alto di infortuni gravi', 'Corpo preparato e protetto'], ['Spese mediche e fisioterapia', 'Prevenzione autonoma efficace'], ['Ricerca di info su mille siti', 'Tutto in un unico sistema testato']].map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-gray-50 transition-colors" data-id="element-118">
            <div className="p-3 md:p-4 text-sm md:text-base text-gray-600 border-r border-gray-200 flex items-center gap-2" data-id="element-119">
              <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-120" />
              <span data-id="element-121">{row[0]}</span>
            </div>
            <div className="p-3 md:p-4 text-sm md:text-base text-gray-900 font-medium flex items-center gap-2 bg-blue-50/30" data-id="element-122">
              <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-123" />
              <span data-id="element-124">{row[1]}</span>
            </div>
          </div>)}
      </div>
    </div>;
}